import { LoadState } from "../../constants/enums";

export interface IVinDecoderState {
  loading: LoadState;
  data: IVinDecodeResponse | null;
  error: string | null;
}

export interface IVinDecodeResponse {
  decodeErrors: IDecodeError[];
  vin: string;
  yearCode: string;
  yearValue: string;
  sequentialNumber: string;
  vehicleType: string;
  marketingMakes: IMarketingMake[];
}

export interface IDecodeError {
  errorCode: string;
  errorMessage: string;
}

export interface IMarketingMake {
  description: string;
  models: IModel[];
}

export interface IModel {
  description: string;
  code: string;
  products: IProduct[];
}

export interface IProduct {
  description: string;
  code: string;
}

export interface IDecodeVinPayload {
  vin: string;
  companyCode: string;
  language: "EN";
  status: "ACTIVE";
}

export const initialVinDecoderState: IVinDecoderState = {
  loading: LoadState.NotLoaded,
  data: null,
  error: null,
};
